module.exports = __webpack_public_path__ + "static/media/stairs--gray.df4e4175.svg";